var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingProjects || _vm.loadingEmployees)?_c('Loading'):_c('v-container',{attrs:{"fluid":""}},[_c('SnackBar',{attrs:{"snackbar":_vm.projectNotification.success,"text":_vm.projectNotification.message}}),_c('div',{attrs:{"id":"projects"}},[_c('ProjectsToolBar'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }